import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { CourierService } from './../../../shared/services/courier.service';
import { GetActiveVoucherRequest, GetActiveVoucherResponse, GetCourierCarRequest, GetCarAndLoaderRequest, GetCarAndLoaderResponse } from './../../../shared/models/courier.models';
import { ActiveUserLocalDataService } from './../../../shared/services/active-user-local-data.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  templateUrl: 'voucher.component.html',
  styleUrls: ['./voucher.component.scss']
})
export class VoucherComponent implements OnInit {
  vouchersResponse: GetActiveVoucherResponse | null = null;
  carAndLoaderResponse: GetCarAndLoaderResponse | null = null;
  loading: boolean = true;
  buttonsLoaded: boolean = false;
  showAdBlueButton: boolean = false;
  isMobile: boolean = false;

  constructor(
    private courierService: CourierService,
    private activeUserLocalDataService: ActiveUserLocalDataService,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.checkIfMobile();
    this.loadVoucherAndCar();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkIfMobile();
  }

  private checkIfMobile() {
    this.isMobile = window.innerWidth <= 768;
  }

  async refreshActiveVoucher() {
  const request: GetActiveVoucherRequest = {};
  try {
    const response = await this.courierService.getActiveVouchers(request).toPromise();
    this.vouchersResponse = response ?? null;
    if (response && response.voucher) {
      this.activeUserLocalDataService.setActiveCourierVoucher(response.voucher);
    } else {
      this.activeUserLocalDataService.setActiveCourierVoucher(null);
    }
  } catch (error) {
    console.error('refreshActiveVoucher: Error fetching active voucher:', error);
  }
}

  async loadCourierCar() {
  try {
    const carId = this.vouchersResponse?.voucher?.carsId;
    if (carId) {
      const carAndLoaderRequest: GetCarAndLoaderRequest = { carId };
      const carAndLoaderResponse = await this.courierService.getCarAndLoader(carAndLoaderRequest).toPromise();
      this.carAndLoaderResponse = carAndLoaderResponse ?? null;
      if (this.carAndLoaderResponse && this.carAndLoaderResponse.carAndLoader.length > 0) {
        const car = this.carAndLoaderResponse.carAndLoader.find(
          x => x.id === carId
        );
        if (car) {
        }
        this.showAdBlueButton = !!(car && car.useAdCard);
      }
    }
  } catch (error) {
    console.error('loadCourierCar: Error fetching car or car and loader:', error);
  }
}

  async loadVoucherAndCar() {
  this.loading = true;
  await this.refreshActiveVoucher();
  await this.loadCourierCar();
  this.loading = false;
}

  navigateTo(route: string) {
    this.router.navigate([route]);
  }
}